import { Config } from '@leverege/plugin'
import { Toast } from '@leverege/ui-elements'

export default {
  id : 'dt.action.CopyEventStartImageUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Image', 'Start' ],
    groupIcons : [ 'fa fa-fw fa-camera' ]
  },
  appearance : () => ( {
    name : 'Copy',
    icon : 'fa fa-fw fa-copy'
  } ),
  handles : ( context ) => {
    const { item } = context

    return item?.startData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const imageBucketUrl = Config.get( 'LinearViewBlock', 'gcsImageBucketUrl' )
    navigator.clipboard.writeText( `${imageBucketUrl}/${item.startData.imagePath}` )

    Toast.success( 'Copied to clipboard!' )
  }
}
